"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require("../");
class ListingModel extends _1.PipelineModel {
    constructor() {
        super(...arguments);
        this.instanceType = 'Listing';
        this.stageLevels = {
            'Pursuit': 0,
            'Marketing': 1,
            'Under Contract': 2,
            'Closed': 3
        };
    }
    static sourcingFromPursuit(pursuit) {
        const listing = new ListingModel();
        // Following line is to remain commented until Deal Sharing is revived
        // listing.systemCommis = true; // Setting this field to true prevents Salesforce from creating a new Commission for this record
        listing.name = pursuit.name;
        listing.onMarketStatus = 'In Sourcing';
        listing.ownerContact = pursuit.clientContactId;
        listing.ownerId = pursuit.ownerId;
        listing.probability = pursuit.probability;
        listing.propertyId = pursuit.propertyId;
        listing.pursuitId = pursuit._id;
        listing.seller = pursuit.clientCompanyId;
        listing.type = pursuit.type;
        listing.commissionInput = pursuit.commissionAmount;
        return listing;
    }
    get salesforceFieldMap() {
        return {
            _id: 'Id',
            acquisitionType: 'McLabs2__Acquisition_Type__c',
            activityId: 'McLabs2__Activity_ID__c',
            askingPriceActual: 'McLabs2__Asking_Price_Actual__c',
            capRate: 'McLabs2__CAP_Rate__c',
            seller: 'McLabs2__Client_Company__c',
            ownerContact: 'McLabs2__Owner_Contact__c',
            commission: 'McLabs2__Commission__c',
            commissionAmount: 'McLabs2__Commission_Input__c',
            dateOffMarket: 'McLabs2__Date_Off_Market__c',
            dateOnMarket: 'McLabs2__Date_On_Market__c',
            expirationDate: 'McLabs2__Listing_Expiration_Date__c',
            market: 'McLabs2__Market__c',
            maxPrice: 'McLabs2__Maximum_Purchase_Price__c',
            maxSqft: 'McLabs2__Maximum_Square_Footage__c',
            maxLeaseRate: 'McLabs2__Maximum_Lease_Rate_SF__c',
            minCapRate: 'McLabs2__Minimum_CAP_Rate__c',
            minCashOnCash: 'McLabs2__Minimum_Cash_on_cash__c',
            minIRR: 'McLabs2__Minimum_IRR__c',
            minLeaseRate: 'McLabs2__Minimum_Lease_Rate_SF__c',
            minLIRR: 'McLabs2__Minimum_LIRR__c',
            minPrice: 'McLabs2__Minimum_Purchase_Price__c',
            minSqft: 'McLabs2__Minimum_Square_Footage__c',
            name: 'Name',
            needDate: 'McLabs2__Need_Date__c',
            noi: 'McLabs2__NOI__c',
            onMarketStatus: 'McLabs2__Status__c',
            ownerId: 'OwnerId',
            probability: 'McLabs2__Probability__c',
            propertyId: 'McLabs2__Property__c',
            pursuitId: 'McLabs2__Proposal__c',
            recordTypeId: 'RecordTypeId',
            repAgreementDate: 'McLabs2__Rep_Agreement_Executed__c',
            spaceSubType: 'McLabs2__Space_Sub_type__c',
            spaceType: 'McLabs2__Space_Type__c',
            subMarket: 'McLabs2__Submarket__c',
            // systemCommis: 'McLabs2__System_Commis__c', // This line is to remain commented until Deal Sharing is revived
            totalReturn: 'McLabs2__Total_Return__c',
            yield: 'McLabs2__Yield__c'
        };
    }
    get daysOnMarket() {
        let daysOnMarket;
        if (this.dateOnMarket) {
            daysOnMarket = Math.floor((new Date().getTime() - new Date(this.dateOnMarket).getTime()) / 86400000);
        }
        return daysOnMarket;
    }
    get isInSourcing() {
        return this.onMarketStatus === ListingModel.STATUSES.IN_SOURCING ||
            (this.onMarketStatus !== ListingModel.STATUSES.IN_NEGOTIATION && this.offers && this.offers.length === 0);
    }
    get isInNegotiations() {
        return this.onMarketStatus === ListingModel.STATUSES.IN_NEGOTIATION ||
            (this.onMarketStatus !== ListingModel.STATUSES.IN_SOURCING && this.offers && this.offers.length > 0);
    }
    get status() {
        return { name: this.stage, level: this.stageLevels[this.stage] };
    }
    get clientContactId() {
        return this.ownerContact;
    }
    set clientContactId(newId) {
        this.ownerContact = newId;
    }
    get clientCompanyId() {
        return this.seller;
    }
    set clientCompanyId(newId) {
        this.seller = newId;
    }
    // TODO commissionInput is still sent by mobile. Remove the getter and setter after updating mobile.
    get commissionInput() {
        return this.commissionAmount;
    }
    set commissionInput(value) {
        this.commissionAmount = value;
    }
    get price() {
        return this.askingPriceActual;
    }
    convertToNegotiation() {
        this.onMarketStatus = 'In Negotiations';
    }
    // need a custom JSON method to return status since getter properties aren't serialized by default.
    toJSON() {
        const json = { status: '', daysOnMarket: 0 };
        Object.keys(this).forEach(key => json[key] = this[key]);
        json.status = this.status;
        json.daysOnMarket = this.daysOnMarket;
        return json;
    }
    transformFromJson(json) {
        delete json.status; // remove getters
        delete json.daysOnMarket;
        Object.assign(this, json);
    }
    transformFromSalesforce(sfListing) {
        super.transformFromSalesforce(sfListing);
        this.propertyType = sfListing.McLabs2__Property_Type1__c;
        this.recordTypeDeveloperName = sfListing.RecordType && sfListing.RecordType.DeveloperName;
        this.stage = sfListing.stage;
        this.type = sfListing.RecordType && sfListing.RecordType.Name;
    }
}
ListingModel.STATUSES = {
    ACTIVE: 'Active',
    CLOSED: 'Closed',
    DEAD: 'Dead',
    IN_CONTRACT: 'In Contract',
    IN_NEGOTIATION: 'In Negotiation',
    IN_SOURCING: 'In Sourcing',
    ON_MARKET: 'On-Market',
    OFF_MARKET: 'Off-Market',
    PRE_MARKETING_PREPARATION: 'Pre-Marketing Preparation'
};
exports.ListingModel = ListingModel;
//# sourceMappingURL=listing.model.js.map